import "./App.css";
import  { useEffect } from "react";
import { createBrowserRouter, Outlet, RouterProvider } from "react-router-dom";
import {
  AboutUs,
  ContactUs,
  CourseDetails,
  EnrollPage,
  ErrorPage,
  Home,
  OurCourses,
  OurHistory,
  OurBranches,
  Privacy,
  CurrentStudents,
  WhyCs,
  Events,
  Resources,
  CoursePage,
  CampusPage,
  Pricing,
  // ContactUs
} from "../src/pages/Index";
import AOS from "aos";
import "aos/dist/aos.css";
// last, so the Macquarie-style base wins over the legacy page stylesheets
import "./styles/mq.css";
const router = createBrowserRouter([
  {
    path: "/",
    element: <Home />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: "team",
        element: (
          <div>
            Hello team! <Outlet />
          </div>
        ),
        children: [
          {
            path: "",
            element: <div>Hel1111111111111111m!</div>,
          },
        ],
      },
    ],
  },
  {
    path: "our-courses",
    element: <OurCourses />,
    errorElement: <ErrorPage />,
  },
  {
    path: "course-detail",
    element: <CourseDetails />,
    errorElement: <ErrorPage />,
  },
  {
    path: "our-history",
    element: <OurHistory />,
    errorElement: <ErrorPage />,
  },
  {
    path: "our-branches",
    element: <OurBranches />,
    errorElement: <ErrorPage />,
  },
  {
    path: "contact-us",
    element: <ContactUs />,
    errorElement: <ErrorPage />,
  },
  {
    path: "about-us",
    element: <AboutUs />,
    errorElement: <ErrorPage />,
  },
  {
    path: "privacy-policy",
    element: <Privacy />,
    errorElement: <ErrorPage />,
  },
  {
    path: "enroll",
    element: <EnrollPage />,
    errorElement: <ErrorPage />,
  },
  {
    path: "current-students",
    element: <CurrentStudents />,
    errorElement: <ErrorPage />,
  },
  {
    path: "why-cs",
    element: <WhyCs />,
    errorElement: <ErrorPage />,
  },
  {
    path: "events",
    element: <Events />,
    errorElement: <ErrorPage />,
  },
  {
    path: "resources",
    element: <Resources />,
    errorElement: <ErrorPage />,
  },
  {
    path: "pricing",
    element: <Pricing />,
    errorElement: <ErrorPage />,
  },
  {
    path: "courses/:yearSlug/:programSlug",
    element: <CoursePage />,
    errorElement: <ErrorPage />,
  },
  {
    path: "campuses/:campusSlug",
    element: <CampusPage />,
    errorElement: <ErrorPage />,
  },
  // Anything that does not match. errorElement only fires for routes that
  // exist, so without this a removed URL — /blogs, say, which was linked
  // publicly for years — gave react-router's bare built-in 404.
  {
    path: "*",
    element: <ErrorPage />,
  },
]);
function App() {
  useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, []);
  return (
    <div className="App">
      <RouterProvider router={router} />
    </div>
  );
}

export default App;
